import { useSearchParams } from 'react-router-dom';

export function admissionPanelSearch(searchParams) {
  const panel = searchParams.get('panel');
  const documentId = searchParams.get('documentId');
  return {
    open: panel === 'admission',
    documentId: documentId || null,
  };
}

export function useAdmissionPanelSearch() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { open, documentId } = admissionPanelSearch(searchParams);

  function openPanel(nextDocumentId) {
    const next = new URLSearchParams(searchParams);
    next.set('panel', 'admission');
    if (nextDocumentId) {
      next.set('documentId', String(nextDocumentId));
    } else {
      next.delete('documentId');
    }
    setSearchParams(next, { replace: true });
  }

  function closePanel() {
    const next = new URLSearchParams(searchParams);
    next.delete('panel');
    next.delete('documentId');
    setSearchParams(next, { replace: true });
  }

  return { open, documentId, openPanel, closePanel };
}
